<template>
  <div>
    <div class="tbd-content">
      <!-- 搜索部分 -->
      <topSearchForm @search="searchList" :showSwtich="false" @export="exportToExcel">
        <el-form :inline="true" class="rform" :model="formSearch" ref="loginform">
          <el-form-item label="状态" class="small1">
            <el-radio-group v-model="formSearch.status" @input="searchList">
              <el-radio label="99">全部</el-radio>
              <el-radio label="1">在保</el-radio>              
              <el-radio label="0">不在保</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="被保险人" class="small1">
            <el-input v-model="formSearch.condition" placeholder="请输入" clearable class="only-input"></el-input>
          </el-form-item>
        </el-form>
      </topSearchForm>

      <el-table border :data="tableData" class="list-table" tooltip-effect="dark" v-loading="listLoading">
        <el-table-column
          type="index"
          width="80"
          label="序号"
        >
        </el-table-column>
        <el-table-column min-width="100px;" label="姓名" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <p v-if="scope.row.status">
              <span>{{ scope.row.name }}</span>
              <span class="status-box" v-if="scope.row.status == '0'">不在保</span>
            </p>
            <span v-else>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="100px;" label="性别" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.sex == '1'">男</span>
            <span v-else>女</span>
            <span></span>
          </template>
        </el-table-column>
        <el-table-column property="cardNoMask" min-width="160px;" label="证件号" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="jobName" min-width="160px;" label="职业名称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="jobCode" min-width="160px;" label="职业编码" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="jobGrade" min-width="160px;" label="职业类别" :show-overflow-tooltip="true"></el-table-column>
      </el-table>

      <el-pagination v-if="pageFlag" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="allData.current" :page-sizes="[10, 20, 30, 40]" :page-size="allData.size"
        layout="total, sizes, prev, pager, next, jumper" :total="allData.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
//当前实例组件
import topSearchForm from "@/components/topSearchForm.vue";
import { common } from "@/api/mixins";

export default {
  props: ['id', 'policyNo', 'orderNo'],
  components: {
    topSearchForm,
  },
  mixins: [common],
  data: () => ({
    listLoading: true,
    pageNum: 1,
    pageSize: 10,
    pageFlag: false,
    allData: null, // 订单列表所有数据
    tableData: [],
    formSearch: {
      status: '1'
    },
  }),

  created() {
    this.getList(); // 获取列表
  },

  methods: {
    // 查询
    searchList() {
      this.pageNum = 1;
      this.getList();
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },

    handleCurrentChange(val) {
      this.pageNum = val;
      this.getList();
    },

    handleParams() {
      let params = JSON.parse(JSON.stringify(this.formSearch));
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      params.orderNo = this.orderNo;
      params.policyNo = this.policyNo;
      for (var key in params) {
        if (params[key] === "") {
          delete params[key];
        }
      }
      if (params.status == '99') {
        delete params.status;
      }
      return params;
    },

    // 订单列表
    getList() {
      this.listLoading = true;
      this.$http({
        url: '/master/group/queryInsureList',
        type: 'POST',
        params: this.handleParams(),
      }).then((res) => {
        this.listLoading = false;
        this.tableData = res.data;
        this.pageFlag = false
        this.allData = res;
        if (this.allData.total != 0) {
          this.pageFlag = true
        }
      })
    },

    // 导出
    exportToExcel() {
      const params = this.handleParams();
      this.$tools.daochu("/master/group/exportInsureList", params, 'POST');
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/.status-box {
  display: inline-block;
  border: 1px solid #999;
  color: #999;
  margin-left: 8px;
  font-size: 10px;
  padding: 4px;
  line-height: 10px;
}
</style>